(function () {
  'use strict';

  var STORAGE_KEY = 'nile_fav_v1';
  var VISITOR_KEY = 'nile_visitor_id';
  var FAV_LOG_ENDPOINT = 'https://jfymxmiktodyhczhlutm.supabase.co/functions/v1/product-favorites';

  function getVisitorId() {
    try {
      var id = localStorage.getItem(VISITOR_KEY);
      if (!id) {
        id = (window.crypto && window.crypto.randomUUID)
          ? window.crypto.randomUUID()
          : 'v-' + Date.now() + '-' + Math.random().toString(36).slice(2);
        localStorage.setItem(VISITOR_KEY, id);
      }
      return id;
    } catch (e) {
      return null;
    }
  }

  function getHandle(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Fire-and-forget: logs the favourite add, never blocks the UI and
  // never lets a network failure surface to the user.
  function logFavouriteAdd(product) {
    try {
      var ctx = window.NileShopContext || {};
      var payload = {
        shop: ctx.shop || null,
        action: 'add',
        product: {
          handle: getHandle(product.url),
          id: product.id
        },
        customer_id: ctx.customerId || null,
        visitor_id: getVisitorId(),
        url: product.url ? (window.location.origin + product.url) : window.location.href
      };
      fetch(FAV_LOG_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (e) {
      // never let logging break the favourites feature
    }
  }

  var Favourites = {
    getAll: function () {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    },
    _save: function (items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      this._updateBadge();
      document.dispatchEvent(new CustomEvent('nile:fav-changed', { detail: { items: items } }));
    },
    has: function (id) {
      var sid = String(id);
      return this.getAll().some(function (p) { return String(p.id) === sid; });
    },
    add: function (product) {
      var items = this.getAll();
      if (!this.has(product.id)) {
        items.push(product);
        this._save(items);
        logFavouriteAdd(product);
      }
    },
    remove: function (id) {
      var sid = String(id);
      var items = this.getAll().filter(function (p) { return String(p.id) !== sid; });
      this._save(items);
    },
    toggle: function (product) {
      if (this.has(product.id)) {
        this.remove(product.id);
        return false;
      }
      this.add(product);
      return true;
    },
    _updateBadge: function () {
      var count = this.getAll().length;
      var badge = document.getElementById('fav-count');
      if (!badge) return;
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    },
    init: function () {
      if (document.readyState === 'loading') {
        var self = this;
        document.addEventListener('DOMContentLoaded', function () { self._updateBadge(); });
      } else {
        this._updateBadge();
      }
    }
  };

  window.NileFavourites = Favourites;
  Favourites.init();
})();
